(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
      
      // --- START URL CLEANUP Edge SEO ---
      // Find all links in the newly loaded section that contain the tracking parameter
      var trackingLinks = productRecommendationsSection.querySelectorAll('a[href*="pr_prod_strat"]');
      trackingLinks.forEach(function(link) {
          try {
              var url = new URL(link.href);
              // Delete all the Shopify recommendation query strings
              url.searchParams.delete('pr_prod_strat');
              url.searchParams.delete('pr_rec_id');
              url.searchParams.delete('pr_rec_pid');
              url.searchParams.delete('pr_ref_pid');
              url.searchParams.delete('pr_seq');
              // Update the link
              link.href = url.toString();
          } catch (e) {
              console.error("Error cleaning URL:", e);
          }
      });
      // --- END URL CLEANUP ---
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
